export default [
  {
    identifier: "WM",
    currency: "usd",
    bank: {
      recipient: "Lemon Way",
      recipientAddress: "8 Rue du Sentier",
      recipientCity: "Paris",
      recipientPostCode: "75002",
      recipientCountry: "France",
      name: "BNP Paribas",
      bankAddress: "81 Boulevard de Sébastopol",
      bankCity: "Paris",
      bankPostCode: "75002",
      bankCountry: "France",
      bic: "BNPAFRPPXXX",
      iban: "FR7630004021180001003630388",
    },
  },
  {
    identifier: "WM",
    currency: "zar",
    bank: {
      recipient: "Pieter Goosen Attorneys Conveyancers and Notaries",
      recipientAddress: "",
      recipientCity: "",
      recipientPostCode: "",
      recipientCountry: "",
      name: "Capitec Business",
      bankAddress: "The Edge Building, Charl Cronje Drive, 3 Howick Close, Tyger Waterfront, Bellville",
      bankCity: "Tygerberg",
      bankPostCode: "7530",
      bankCountry: "South Africa",
      bic: "CABLZAJJ",
      iban: "",
      bankBranchCode: "450105",
      bankAccountNo: "1050949927",
      bankAccountType: "Current",
    },
  },
];
